import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAllTacoFoods, getTacoFoodById, getTaco4Foods, getTaco4FoodById } from '../../service/api';


// Fetch all Taco foods
export const fetchAllTacoFoods = createAsyncThunk(
  'nutridata/fetchAllTacoFoods',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllTacoFoods();
      // console.log(JSON.stringify(response));
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
)

export const fetchTacoFoodById = createAsyncThunk(
  'nutridata/fetchTacoFoodById',
  async (food_id, { rejectWithValue }) => {
    try {
      const response = await getTacoFoodById(food_id);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchTaco4Foods = createAsyncThunk(
  'nutridata/fetchTaco4Foods',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getTaco4Foods();
      // console.log("Api Taco4Foods: " + JSON.stringify(response));
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchTaco4FoodById = createAsyncThunk(
  'nutridata/fetchTaco4FoodById',
  async (food_id, { rejectWithValue }) => {
    try {
      const response = await getTaco4FoodById(food_id);
      console.log("Api da Action Taco4FoodById: " + JSON.stringify(response));
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);